module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/tn9K2L/images/9781439655153.jpg?1700070684407",
      "alt": "This image is the cover for the book Legendary Locals of Toledo, Legendary Locals"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Legendary Locals of Toledo, Legendary Locals\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("While Jesup W. Scott proclaimed it the \"Future Great City of the World\" in 1868, in reality, Toledo saw little development for the first four decades after its founding in 1837. Plagued by swamps, disease, and unwelcoming occupants, few settled here. But slowly, the city attracted people who saw a chance to improve their lives and perhaps their fortunes, including Edward Drummond Libbey. In 1888, Libbey brought with him the glass industry that would dominate the city's economy and earn it the nickname of \"Glass Capital of the World.\" Legendary Locals of Toledo describes the impact of people like Scott, Libbey, and others who shaped Toledo--from the well known whose names grace street signs, buildings, and monuments, to unsung heroes who few remember. Included are pioneers who were the first in their fields as well as leaders of business and industry, representatives of government and the law, and successful entertainers and sports figures. Some were born here and moved on to make their impact, while others lived here and impacted the city.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Barbara L. Floyd\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Barbara L. Floyd is director of the Ward M. Canaday Center for Special Collections at the University of Toledo. This book utilizes images from the center's collections and other local libraries and archives.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0